/**
 * 面试经历服务层
 * 提供管理端和 C 端的面试经历相关 API 调用
 */

import {
  ResponseDTO,
  CExperienceDetailDTO,
  CExperienceListResponse,
} from '@/types';
import request from '@/utils/request';



// ============ C 端接口 ============

/** C 端面试经历列表查询参数 */
export interface CExperienceListParams {
  /** 页码，默认 1 */
  page?: number;
  /** 每页数量，默认 20 */
  pageSize?: number;
  /** 按标签筛选 */
  tag?: string;
}

/**
 * 获取面试经历列表（C 端）
 * 分页查询已发布的面试经历列表，仅返回 published 状态的数据。
 * @param params 分页和筛选参数
 * @returns 分页后的面试经历列表
 */
export function getExperienceList(params: CExperienceListParams): Promise<CExperienceListResponse> {
  return request
    .get<
      CExperienceListResponse,
      ResponseDTO<CExperienceListResponse>,
      CExperienceListParams
    >('/interview-experience', { params })
    .then((res: ResponseDTO<CExperienceListResponse>) => res.data);
}

/**
 * 获取面试经历详情（C 端）
 * 根据业务编号查询面试经历详情，包含完整的 context 字段（Markdown 格式）。
 * @param experienceNumber 面试经历业务编号
 * @returns 面试经历详情
 */
export function getExperience(experienceNumber: number): Promise<CExperienceDetailDTO> {
  return request
    .get<
      CExperienceDetailDTO,
      ResponseDTO<CExperienceDetailDTO>,
      void
    >(`/interview-experience/${experienceNumber}`)
    .then((res: ResponseDTO<CExperienceDetailDTO>) => res.data);
}
